import React from 'react'
import CancelOutlined from '@material-ui/icons/CancelOutlined'

export default function CancelOutlinedIcon() {

    return (
        <CancelOutlined />
    )
}